import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { TABLES } from '../lib/tables';
import { useNavigate } from 'react-router-dom';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showTeacherPassword, setShowTeacherPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetSent, setResetSent] = useState(false);

  
  const SPECIAL_PASSWORDS = {
    profesor: 'SRBLiceu2025Profesor',
    coordonator: 'SRBLiceu2025Coordonator'
  };

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    nume: '',
    prenume: '',
    rol: 'elev',
    specializare: 'MI',
    clasa: '',
    telefon: '',
    confirmPassword: '',
    specialPassword: '', 
  });

  const [teacherPasswordError, setTeacherPasswordError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    
    if (name === 'rol') {
      setFormData({
        ...formData,
        [name]: value,
        specialPassword: '', 
        clasa: '',
      });
      setTeacherPasswordError(''); 
    } else if (name === 'specializare') {
      setFormData({
        ...formData,
        [name]: value,
        clasa: '',
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  
  const validateSpecialPassword = () => {
    if (formData.rol === 'elev') {
      return true; 
    }
    
    if (!formData.specialPassword) {
      setTeacherPasswordError(`Introdu parola specială pentru ${formData.rol}`);
      return false;
    }
    
    const correctPassword = SPECIAL_PASSWORDS[formData.rol];
    if (formData.specialPassword !== correctPassword) {
      setTeacherPasswordError('Parolă specială incorectă');
      return false;
    }
    
    setTeacherPasswordError('');
    return true;
  };

  const validateForm = () => {
    
    setError('');
    setTeacherPasswordError('');

    
    if (!formData.email || !formData.password) {
      setError('Completează email-ul și parola');
      return false;
    }

    if (!isLogin) {
      if (!formData.nume || !formData.prenume) {
        setError('Completează numele și prenumele');
        return false;
      }
      if (formData.password !== formData.confirmPassword) {
        setError('Parolele nu se potrivesc');
        return false;
      }
      if (formData.password.length < 6) {
        setError('Parola trebuie să aibă minim 6 caractere');
        return false;
      }
      
      
      if (!validateSpecialPassword()) {
        return false;
      }
      
      if (formData.rol === 'elev' && !formData.clasa) {
        setError('Selectează clasa');
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setTeacherPasswordError('');
    setSuccess('');

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      if (isLogin) {
        
        const { data, error } = await supabase.auth.signInWithPassword({
          email: formData.email,
          password: formData.password,
        });

        if (error) throw error;

        setSuccess('Autentificare reușită! Redirecționare...');
        setTimeout(() => navigate('/dashboard'), 1500);

      } else {
        
        const { data: authData, error: authError } = await supabase.auth.signUp({
          email: formData.email,
          password: formData.password,
          options: {
            data: {
              nume: formData.nume,
              prenume: formData.prenume,
              rol: formData.rol,
              specializare: formData.specializare || null,
              telefon: formData.telefon || null,
              clasa: formData.rol === 'elev' ? formData.clasa : null,
            }
          }
        });

        if (authError) throw authError;

        try {
          const { error: profileError } = await supabase
            .from(TABLES.profiles)
            .upsert(
              {
                id: authData.user.id,
                email: formData.email,
                nume: formData.nume,
                prenume: formData.prenume,
                rol: formData.rol,
                specializare: formData.specializare || null,
                telefon: formData.telefon || null,
                clasa: formData.rol === 'elev' ? formData.clasa : null,
              },
              {
                onConflict: 'id',
              }
            );

          if (profileError) {
            console.warn('Profile upsert failed (trigger should have created it):', profileError.message);
          }
        } catch (upsertErr) {
          console.warn('Profile upsert error (non-fatal):', upsertErr);
        }

        setSuccess(`Cont ${formData.rol} creat cu succes! Poți să te autentifici acum.`);
        setTimeout(() => setIsLogin(true), 2000);
      }
    } catch (err) {
      console.error('Auth error:', err);
      setError(err.message || 'Eroare la autentificare');
    } finally {
      setLoading(false);
    }
  };
  
  const shouldShowClassField = !isLogin && formData.rol === 'elev';

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    setResetSent(false);

    try {
      if (!resetEmail) {
        throw new Error('Introdu adresa de email');
      }

      const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
        redirectTo: `${window.location.origin}/update-password`,
      });

      if (error) throw error;

      setResetSent(true);
      setSuccess('Link-ul de resetare a fost trimis! Verifică-ți email-ul.');
    } catch (err) {
      console.error('Reset password error:', err);
      setError(err.message || 'Eroare la trimiterea email-ului de resetare');
    } finally {
      setLoading(false);
    }
  };

return (
  <div className="login-container">
    <div className="login-card">
      {/* Logo școală */}
      <div className="login-header">
        <img 
          src="/srbiconita.png" 
          alt="Logo Școală" 
          className="school-logo"
        />
        <h1 className="login-title">Sistem Credite Educaționale</h1>
        <p className="login-subtitle">
          {showResetPassword 
            ? 'Resetare Parolă' 
            : isLogin 
              ? 'Autentificare' 
              : 'Înregistrare cont nou'
          }
        </p>
      </div>

      {/* Mesaje */}
      {error && (
        <div className="alert alert-error">
          {error}
        </div>
      )}
      
      {success && (
        <div className="alert alert-success">
          {success}
        </div>
      )}

      {/* AFIȘEAZĂ FORMULARUL DE RESET PASSWORD */}
      {showResetPassword ? (
        <form onSubmit={handleResetPassword} className="login-form">
          <div className="form-grid">
            <div className="form-group full-width">
              <label className="form-label">
                Adresa de email asociată contului *
              </label>
              <input
                type="email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
                className="form-input"
                placeholder="ex: nume@școală.ro"
                disabled={resetSent}
              />
            </div>
          </div>

          {!resetSent ? (
            <>
              <button
                type="submit"
                disabled={loading}
                className="submit-btn"
              >
                {loading ? (
                  <span className="loading-spinner"></span>
                ) : (
                  'Trimite link de resetare'
                )}
              </button>

              <div className="toggle-mode">
                <button
                  type="button"
                  onClick={() => setShowResetPassword(false)}
                  className="toggle-btn"
                >
                  ← Înapoi la autentificare
                </button>
              </div>
            </>
          ) : (
            <div className="success-message">
              <p>Link-ul a fost trimis! Verifică-ți căsuța de email.</p>
              <p><small>Dacă nu găsești email-ul, verifică și folderul Spam.</small></p>
              
              <div className="toggle-mode" style={{ marginTop: '20px' }}>
                <button
                  type="button"
                  onClick={() => {
                    setShowResetPassword(false);
                    setResetSent(false);
                  }}
                  className="toggle-btn"
                >
                  ← Înapoi la autentificare
                </button>
              </div>
            </div>
          )}
        </form>
      ) : (
        // formularul normal de login/register
        <>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-grid">
              {/* Email */}
              <div className="form-group full-width">
                <label className="form-label">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="ex: nume@școală.ro"
                />
              </div>

              {/* Password */}
              <div className="form-group full-width">
                <label className="form-label">
                  <span className="label-icon"></span>
                  Parola ta *
                </label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Alege o parolă sigură (minim 6 caractere)"
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? '●' : '○'}
                  </button>
                </div>
              </div>

              {/* Register fields - doar pentru înregistrare */}
              {!isLogin && (
                <>
                  {/* Nume și Prenume */}
                  <div className="form-group half-width">
                    <label className="form-label">Nume *</label>
                    <input
                      type="text"
                      name="nume"
                      value={formData.nume}
                      onChange={handleChange}
                      required
                      className="form-input"
                      placeholder="Nume"
                    />
                  </div>

                  <div className="form-group half-width">
                    <label className="form-label">Prenume *</label>
                    <input
                      type="text"
                      name="prenume"
                      value={formData.prenume}
                      onChange={handleChange}
                      required
                      className="form-input"
                      placeholder="Prenume"
                    />
                  </div>

                  {/* Rol */}
                  <div className="form-group half-width">
                    <label className="form-label">Rol *</label>
                    <select
                      name="rol"
                      value={formData.rol}
                      onChange={handleChange}
                      className="form-select"
                    >
                      <option value="elev">Elev</option>
                      <option value="profesor">Profesor</option>
                      <option value="coordonator">Coordonator</option>
                    </select>
                  </div>

                  {/* Specializare - doar pentru elevi */}
                  {formData.rol === 'elev' && (
                    <div className="form-group half-width">
                      <label className="form-label">Specializare *</label>
                      <select
                        name="specializare"
                        value={formData.specializare}
                        onChange={handleChange}
                        className="form-select"
                      >
                        <option value="MI">Matematică-Informatică</option>
                        <option value="SN">Științe ale Naturii</option>
                        <option value="SS">Științe Sociale</option>
                        <option value="FL">Filologie</option>
                        <option value="BU">Business</option>
                      </select>
                    </div>
                  )}

                  {/* Clasa - doar pentru elevi */}
                  {shouldShowClassField && (
                    <div className="form-group half-width">
                      <label className="form-label">Clasa *</label>
                      <select
                        name="clasa"
                        value={formData.clasa}
                        onChange={handleChange}
                        required={formData.rol === 'elev'}
                        className="form-select"
                        disabled={!formData.specializare}
                      >
                        <option value="">Selectează clasa</option>
                        {formData.specializare ? (
                          [9, 10, 11, 12].map((an) => (
                            <option 
                              key={`${an}${formData.specializare}`} 
                              value={`${an}${formData.specializare}`}
                            >
                              Clasa {an}{formData.specializare}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            Selectează mai întâi specializarea
                          </option>
                        )}
                      </select>
                      
                      {/* Mesaj informativ */}
                      {!formData.specializare && (
                        <div className="form-hint" style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                          Selectează mai întâi specializarea pentru a vedea clasele disponibile
                        </div>
                      )}
                    </div>
                  )}

                  {/* Telefon */}
                  <div className="form-group half-width">
                    <label className="form-label">Telefon</label>
                    <input
                      type="tel"
                      name="telefon"
                      value={formData.telefon}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="ex: 0722 123 456"
                    />
                  </div>

                  {/* Parola specială pentru profesor/coordonator */}
                  {(formData.rol === 'profesor' || formData.rol === 'coordonator') && (
                    <div className="form-group full-width">
                      <label className="form-label">
                        Parolă specială {formData.rol === 'profesor' ? 'profesor' : 'coordonator'} *
                      </label>
                      <div className="password-wrapper">
                        <input
                          type={showTeacherPassword ? "text" : "password"}
                          name="specialPassword"
                          value={formData.specialPassword}
                          onChange={handleChange}
                          required={formData.rol !== 'elev'}
                          className="form-input"
                          placeholder={`Introdu parola specială pentru ${formData.rol === 'profesor' ? 'profesor' : 'coordonator'}`}
                        />
                        <button
                          type="button"
                          className="password-toggle"
                          onClick={() => setShowTeacherPassword(!showTeacherPassword)}
                        >
                          {showTeacherPassword ? '●' : '○'}
                        </button>
                      </div>
                      {teacherPasswordError && (
                        <div className="error-message">
                          {teacherPasswordError}
                        </div>
                      )}
                      <div className="password-hint">
                        <small>(Aceasta parola este cunoscuta doar de administrator)</small>
                      </div>
                    </div>
                  )}

                  {/* Confirm Password */}
                  <div className="form-group full-width">
                    <label className="form-label">
                      Confirmă parola ta *
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                      className="form-input"
                      placeholder="Reintrodu parola ta"
                    />
                  </div>
                </>
              )}
            </div>

            {/* Submit button */}
            <button
              type="submit"
              disabled={loading}
              className="submit-btn"
            >
              {loading ? (
                <span className="loading-spinner"></span>
              ) : isLogin ? (
                'Autentifică-te'
              ) : (
                'Creează cont'
              )}
            </button>
          </form>

          {/* Toggle mode și link pentru reset password */}
          <div className="toggle-mode">
            <button
              onClick={() => setIsLogin(!isLogin)}
              className="toggle-btn"
            >
              {isLogin 
                ? 'Nu ai cont? Înscrie-te aici' 
                : 'Ai deja cont? Autentifică-te'
              }
            </button>
            
            {/* Adaugă acest buton pentru reset password DOAR în modul login */}
            {isLogin && (
              <button
                onClick={() => setShowResetPassword(true)}
                className="toggle-btn"
                style={{
                  marginTop: '10px',
                  fontSize: '14px',
                  color: '#666'
                }}
              >
                Ai uitat parola?
              </button>
            )}
          </div>
        </>
      )}

      {/* Footer */}
      <div className="login-footer">
        <p className="footer-text">
          © {new Date().getFullYear()} Sistem Credite Educaționale
        </p>
        <div className="school-footer">
          <img 
            src="/SiglaLiceuRem.png" 
            alt="Sigla Liceului" 
            className="footer-logo"
            style={{ width: '128px', height: '128px', objectFit: 'contain' }}
          />
          <span className="footer-school">Școala Romano-Britanică</span>
        </div>
        <p style={{ marginTop: '8px', fontSize: '11px', color: '#999' }}>
          Developed by{' '}
          <a
            href="https://github.com/Dorogea"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#888', textDecoration: 'none' }}
            onMouseOver={(e) => e.target.style.color = '#4F46E5'}
            onMouseOut={(e) => e.target.style.color = '#888'}
          >
            Eduard Dorogea
          </a>
          {' · '}
          <a
            href="https://www.linkedin.com/in/eduard-dorogea-263072236/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#888', textDecoration: 'none' }}
            onMouseOver={(e) => e.target.style.color = '#0077b5'}
            onMouseOut={(e) => e.target.style.color = '#888'}
          >
            LinkedIn
          </a>
        </p>
      </div>
    </div>
  </div>
  );
}